import emptyIcon from "@/assets/emptyIcon.png";
import {
  getUserNoticeList,
  setAllRead,
  setNoticeRead,
} from "@/services/api/url";
import { BellOutlined, SmileOutlined } from "@ant-design/icons";
import { history, SelectLang as UmiSelectLang } from "@umijs/max";
import type { MenuProps } from "antd";
import { Dropdown, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import "./index.less";

export type SiderTheme = "light" | "dark";

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Notice: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [items, setItems] = useState<MenuProps["items"]>([
    {
      key: "1",
      label: "系统通知",
      disabled: true,
    },
    {
      type: "divider",
    },

    {
      type: "divider",
    },
    {
      key: "999",
      label: (
        <div className="right-footer">
          <span className="right-all">全部已读</span>
          <span
            className="right-view-all"
            onClick={() => history.push("/all-notice")}
          >
            查看所有通知
          </span>
        </div>
      ),
    },
  ]);
  const [isDotShow, setIsDotShow] = useState(false);
  const [noticeDetail, setNoticeDetail] = useState({
    title: "",
    Content: "",
  });
  const handelNotice = (item: any) => {
    console.log(item);
    if (item.readStatus === "0") {
      setNoticeRead(item.id);
    }
    setNoticeDetail({
      title: item.noticeTitle,
      Content: item.noticeContent,
    });
    setOpen(true);
  };

  const getUserNoticeData = async () => {
    if (history.location.pathname === "/main" || history.location.pathname === "/") {
      return;
    }
    console.log("获取消息通知");

    let res = await getUserNoticeList({
      pageNum: 1,
      pageSize: 5,
      readStatus: "0",
    });
    console.log(res, "消息通知");
    let noticeList: any[] = [];
    if (res.code == 200) {
      if (res.rows[0] && res.rows[0].readStatus === "0") {
        setIsDotShow(true);
      }

      if (res.rows.length == 0) {
        noticeList = [
          {
            key: "bbb",
            className: "empty-item",
            label: (
              <div className="empty-box">
                <img src={emptyIcon} className="empty-img" alt="" />
                <span className="empty-text">暂无未读信息</span>
              </div>
            ),
          },
        ];
      } else {
        noticeList = res.rows.map((item: any, index: any) => {
          return {
            key: index + 5,
            label: (
              <div className="right-content" onClick={() => handelNotice(item)}>
                <span className="right-title">{item.noticeTitle}</span>
                <span className="right-time">{item.noticeTitle}</span>
                <span className="right-text">
                  {item.noticeContent || "暂无内容"}
                </span>
              </div>
            ),
            icon: <SmileOutlined />,
          };
        });
      }
      console.log(noticeList, 222);

      setItems([
        {
          key: "1",
          label: "系统通知",
          disabled: true,
        },
        {
          type: "divider",
        },
        ...noticeList,
        {
          type: "divider",
        },
        {
          key: "999",
          label: (
            <div className="right-footer">
              <span
                className="right-all"
                onClick={async () => {
                  const res = await setAllRead();
                  if (res.code == 200) {
                    message.success("全部已读成功");
                  }
                }}
              >
                全部已读
              </span>
              <span
                className="right-view-all"
                onClick={() => history.push("/all-notice")}
              >
                查看所有通知
              </span>
            </div>
          ),
        },
      ]);
    }
  };

  useEffect(() => {
    getUserNoticeData();
  }, []);

  return (
    <div>
      <Dropdown overlayClassName="down-content" menu={{ items }}>
        <div style={{ position: "relative" }}>
          <BellOutlined />
          <div
            className="red-dot"
            style={{ display: isDotShow ? "inline-block" : "none" }}
          ></div>
        </div>
      </Dropdown>
      <Modal
        width={640}
        height={600}
        title={<p>{noticeDetail.title}</p>}
        footer={null}
        open={open}
        onCancel={() => {
          setOpen(false);
          setNoticeDetail({
            title: "",
            Content: "",
          });
        }}
      >
        {noticeDetail.Content}
      </Modal>
    </div>
  );
};
